import { Button, Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FiGrid, FiList, FiPlus, FiUpload } from "react-icons/fi";
import { useState } from "react";
import AddDealModal from "../../modals/deals/AddDealModal";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";

import { Breadcrumb, Col } from "react-bootstrap";
const DealsHeader = ({ onAdd, title, openModal }) => {
  const location = useLocation();
  const [show, setShow] = useState(false);

  return (
    <div
      style={{ padding: "10px", background: "#f8f9fa" }}
      className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
    >
      {/* LEFT */}
      <Col md={4} sm={12}>
        <div className="my-auto mb-2">
          <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Deals</h4>

          <Breadcrumb
            style={{
              background: "transparent",
              padding: 0,
              margin: 0,
              fontSize: "14px",
            }}
          >
            <Breadcrumb.Item>
              <Link to="/">
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
                  }}
                />
              </Link>
            </Breadcrumb.Item>

            <MdKeyboardArrowRight className="mt-1 fs-5" />

            <Breadcrumb.Item
              linkAs="span"
              className="text-dark text-decoration-none fs-6"
            >
              Deals
            </Breadcrumb.Item>

            <MdKeyboardArrowRight className="mt-1 fs-5" />

            <Breadcrumb.Item active>
              <span className="text-dark fs-6">{title}</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </Col>

      {/* RIGHT */}
      <div className="d-flex align-items-center flex-wrap gap-2">
        {/* VIEW SWITCH */}
        <div className="d-flex align-items-center border rounded p-1 bg-white">
          <Link
            to="/deals-list"
            className={`btn btn-sm ${
              location.pathname === "/deals-list"
                ? "btn-orange text-white"
                : "btn-light"
            }`}
          >
            <FiList />
          </Link>

          <Link
            to="/deals-grid"
            className={`btn btn-sm ${
              location.pathname === "/deals-grid"
                ? "btn-orange text-white"
                : "btn-light"
            }`}
          >
            <FiGrid />
          </Link>
        </div>

        {/* EXPORT */}
        <Dropdown>
          <Dropdown.Toggle className="btn btn-light border border-1 d-flex align-items-center">
            <FiUpload className="me-1" /> Export
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            <Dropdown.Item>Export as PDF</Dropdown.Item>
            <Dropdown.Item>Export as Excel</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* ADD DEAL */}
        <Button
          className="btn-orange d-flex align-items-center"
          onClick={() => setShow(true)}
        >
          <FiPlus className="me-1" /> Add Deal
        </Button>
        <AddDealModal show={show} handleClose={() => setShow(false)} />
      </div>
      <style>
        {`
               /* ORANGE THEME */
.btn-orange {
  background-color: #f26522;
  border: none;
}

.btn-orange:hover {
  background-color: #e5531a;
}

// /* HEADER */
// .page-breadcrumb {
//   background: #f8f9fa;
//   padding: 15px;
//   border-radius: 8px;
// }

/* CALENDAR ICON */
.calendar-icon {
  position: absolute;
  right: 10px;
  top: 38px;
  color: #999;
  cursor: pointer;
}

/* MODAL */
.modal-content {
  border-radius: 10px;
}

.modal-header {
  border-bottom: 1px solid #eee;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .page-breadcrumb {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .page-breadcrumb .right-content {
    margin-top: 10px;
  }
}`}
      </style>
    </div>
  );
};

export default DealsHeader;
